import { Component } from '@angular/core';

@Component({
  selector: 'app-public-engage',
  templateUrl: './public-engage.component.html',
  styleUrls: ['./public-engage.component.scss']
})
export class PublicEngageComponent {


  openSameTab(ev: Event, href: string) {
    ev.preventDefault();                // evita navegação SPA
    window.location.assign(href);       // navega na mesma aba com reload
    // window.location.replace(href);   // se não quiser empilhar no histórico
  }
  
}
